import {Component, Input, Output, EventEmitter} from '@angular/core';
import {DigitalBusinessCard} from 'app/digital-business-card/digital-business-card.model';
import {DBC_FORM_FIELD, DBC_ONBOARD_V2_SCREENS} from '../../dbc-onboard-v2.utils';

export enum IMAGE_TYPE {
    PROFILE,
    LOGO
}

@Component({
    selector: 'app-dbc-mobile-form',
    templateUrl: './dbc-mobile-form.component.html',
    styleUrls: ['./dbc-mobile-form.component.scss'],
})
export class DbcMobileFormComponent {

    @Input() dbc: DigitalBusinessCard;
    @Input() fullPhoneNumber: string;
    @Input() countryNameCode: string;
    @Input() phoneNumber: string;
    @Input() colorOptions: string[];
    @Input() userImageUrl: string;
    @Input() logoUrl: string;
    @Input() isFirstNameMissing: boolean;
    @Input() isInvalidEmail: boolean;
    @Input() defaultColorPickerBackground: string;
    @Input() layoutPrimaryColor: string;
    @Input() showSaveLoader: boolean;
    @Input() emailInputErrorMessage: string;


    @Output() inputValueChange = new EventEmitter<{value: string, type: DBC_FORM_FIELD}>();
    @Output() onCountryFlagChange = new EventEmitter<string>();
    @Output() imageSelected = new EventEmitter<{ type: IMAGE_TYPE, file: File }>();
    @Output() onSaveCardClicked = new EventEmitter<boolean>();
    @Output() openEditImageModal = new EventEmitter<IMAGE_TYPE>();

    // Component Variables
    currentScreen: number = DBC_ONBOARD_V2_SCREENS.ONBOARDING_FORM

    // enums
    DBC_ONBOARD_V2_SCREENS = DBC_ONBOARD_V2_SCREENS;
    IMAGE_TYPE = IMAGE_TYPE;
    titleText: string = 'Create your free card in minutes!'
    descriptionText: string = 'Enter your details to make a personalized digital business card.'

    constructor() {}

    // Form change functions
    handleImageSelected(event: {type: IMAGE_TYPE, file: File}) {
        if (event.file) {
            this.imageSelected.emit({ type: event.type, file: event.file });
        }
    }

    handleFormUpdated({value, type}: { value: string, type: DBC_FORM_FIELD }) {
        this.inputValueChange.emit({value, type})
    }

    handleOpenEditImageModal($event: IMAGE_TYPE) {
        this.openEditImageModal.emit($event);
    }

    onSave() {
        this.onSaveCardClicked.emit();
    }

    countryFlagChange(countryCallingCode: string) {
        this.onCountryFlagChange.emit(countryCallingCode);
    }

}
